module.exports = __webpack_public_path__ + "img/home_27.0ca23ea5.png";